import OrderPendingTimer from '../pageInside/payments/OrderPendingTimer';
import { orderText } from '../pageInside/payments/orderManagementText';
import React, { useState, useEffect, useRef } from "react";
import {

  isAuthenticated,
  OrdersViewById,
  updateOrder,
  getGraphicOrder,
  acceptOrder,
  rejectOrder,
  getCJPaymentMode,
} from "../auth";
import Modal from "react-bootstrap/Modal";
import Printer from "../pageInside/printerLabel1";
import Filters from "../pageInside/FilterProduct";
import { retrievePayment, getPaymentIntentView } from "../auth/stripe";
import { taxProductAreaByState } from "../auth/apiProduct";
import SubmitCancelButtonSlider from "../pageInside/SubmitCancelButtonSlider";
import ShowimagesLoading from "../pageInside/showImagesLoading";
import OrderNoteMessage from "../pageInside/orderNoteMessage";
import OrderFinancialActions from "../pageInside/payments/OrderFinancialActions";
import TrackingCapture, { trackingFromBarcode } from "../pageInside/TrackingCapture";
import { getShippingProviderStatus, updateOrderShippingMode, getOrderTracking } from "../auth/shippingApi";
import {
  ItemsOrder,
  prodDiscount,
  prodPrice,
  prodFrService,
  prodFrVente,
  prodFrRef,
  TaxOrder,
  getTotal,
  prodFrTransaction,
  totalFrais,
  inComeSeller,
  elakayFrais,
  calProfit,
} from "../auth/allPriceFeet";
// import {
//   DesignsList,
//   DesignPreviewModal,
//   parseLoadedDesign
// } from "../pageInside/Graffiticonfiguratorartifact/externPageGraffiti/GraffitiPreview";

import GraffitiOrderSeller from "../pageInside/Graffiticonfiguratorartifact/GraffitiOrderSeller";
import moment from "moment";
import imgProductLakay from "../Layout/imgs/md3.jpg";
import "./Ordersview_.css";
import { elakayAutoText } from "../pageInside/dataElakay";
import { Link } from "react-router-dom";
import { useDropshippingText } from "../dropshippingInterne/i18n";
import { isProviderFulfilled, safeTrackingUrl, statusLabel } from "../dropshippingInterne/ui/orderFulfillment";
import { sellerAcceptsPayment } from "../dropshippingInterne/ui/paymentAcceptance";


let __elakayInfoSource;
const __setElakayInfoSource = (infoSource) => { if (infoSource) __elakayInfoSource = infoSource; };
const __elakayText = (key, fallback) =>
  __elakayInfoSource?.laguangeElakay?.("frontElakayHardcodedText", __elakayInfoSource.languageAPI)?.["orderShipped"]?.[key] || fallback;

// --- Helpers ---------------------------------------------------------


const filterProductSel = (fil) => {
  if (fil.products && fil.products.filter) {
    return fil.products.filter;
  } else if (fil.prod_filterProduct && fil.prod_filterProduct.filter) {
    return fil.prod_filterProduct.filter;
  } else {
    return { type: "none", size: "none", color: "none" };
  }
};

function isValidUrl(str) {
  try {
    new URL(str);
    return true;
  } catch (_) {
    return false;
  }
}

const buildCarrierTrackingUrl = (carrier, trackingNumber) => {
  const tracking = encodeURIComponent(String(trackingNumber || "").trim());
  if (!tracking) return "";

  const urls = {
    USPS: `https://tools.usps.com/go/TrackConfirmAction?tLabels=${tracking}`,
    UPS: `https://www.ups.com/track?tracknum=${tracking}`,
    FedEx: `https://www.fedex.com/fedextrack/?trknbr=${tracking}`,
    "DHL eCommerce": `https://webtrack.dhlglobalmail.com/?trackingnumber=${tracking}`,
    OnTrac: `https://www.ontrac.com/tracking/?number=${tracking}`
  };

  return urls[carrier] || "";
};

const cleanTrackingUrl = (value) => String(value || "").trim();

const getCustomerTrackingUrl = (order) => cleanTrackingUrl(
  order?.products?.delivery?.trackingUrl || order?.delivery?.trackingUrl
);

const resolveTrackingUrl = (order, carrier, trackingNumber, currentUrl = "") => (
  getCustomerTrackingUrl(order)
  || cleanTrackingUrl(currentUrl)
  || buildCarrierTrackingUrl(carrier, trackingNumber)
);

function ReadMoreLess({ infoSource, text, textLess = "futur." }) {
  __setElakayInfoSource(infoSource);
  const [isExpanded, setIsExpanded] = useState(false);

  const toggleExpand = () => setIsExpanded(!isExpanded);

  const previewLength = text.indexOf(textLess) + (textLess?.length || 0);
  const previewText = text.slice(0, previewLength);
  const remainingText = text.slice(previewLength);
  const seeMore = infoSource.language(infoSource, "Link", "seeMore");
  const seeLess = infoSource.language(infoSource, "Link", "seeLess");

  return (
    <div className="ordersview-read-more">
      <p>
        <strong>{infoSource.laguangeElakay("frontElakayHardcodedText", infoSource.languageAPI).orderShipped.t001}</strong>
        {previewText}
        {!isExpanded && "..."}
        {isExpanded && remainingText}
        <span
          className="ordersview-read-more-link"
          onClick={toggleExpand}
        >
          {isExpanded ? seeLess : seeMore}
        </span>
      </p>
    </div>
  );
}

// --- Component principal ---------------------------------------------

const Orders = (props) => {
  const { infoSource, getOrderID, setShowOrderView, showOrderView, onUpdated, clotureFeet = 0.5, readOnly = false } = props;
  __setElakayInfoSource(infoSource);

  const simulationPriceBase = {
    ItemsOrder: 0,
    prodDiscount: 0,
    prodPrice: 0,
    prodFrService: 0,
    prodFrVente: 0,
    prodFrRef: 0,
    TaxOrder: 0,
    getTotal: 0,
    prodFrTransaction: 0,
    totalFrais: 0,
    inComeSeller: 0,
    elakayFrais: 0,
    statut: { profit: 0, loss: 0, statut: "break-even point" },
  };

  const infoValue = {
    carrier: "",
    tracking: "",
    urlTracking: "",
    url_label: "",
  };

  const { token } = isAuthenticated();

  const [orders, setOrders] = useState([]);
  const ot = useDropshippingText(infoSource, "dropshippingOrders");
  const providerFulfilled = isProviderFulfilled(orders?.products);
  const fulfillmentReadOnly = readOnly || providerFulfilled;
  const [loading, setLoading] = useState(false);
  const [ordersShipping, setOrdersShipping] = useState({});
  const [showLabel, setShowLabel] = useState(false);
  const [showTracking, setShowTracking] = useState(false);
  const [info, setInfo] = useState(infoValue);
  const [label_Tracking, setLabel_Tracking] = useState([false, false]);
  const [orderPayment, setOrderPayment] = useState({});
  const [getSimulationPrice, setSimulationPrice] = useState(simulationPriceBase);
  // {galeries:[...]} shape, not a bare array -- GraffitiOrderSeller's
  // ImageGallery reads ImagesProd?.galeries (an array of {urlImg}). See
  // (ImagesProd?.galeries?.map(...)) -- see loadOrders below.
  const [galeries, setGaleries] = useState({ galeries: [] })
  // PAYMENT-only loading/message/error (Accept & Capture / Refuse). Kept
  // deliberately separate from shippingSaveState below -- payment and
  // shipping are two independent workflows (task spec §26 "PAYMENT ≠
  // SHIPPING. Do not couple them"); a shipping save in flight must never
  // disable the payment button and vice versa.
  const [checkoutState, setCheckoutState] = useState({
    loading: false,
    message: "",
    error: ""
  });
  // SHIPPING-only loading/message/error (Update Shipping / manual
  // tracking form). Independent of checkoutState/payment on purpose.
  const [shippingSaveState, setShippingSaveState] = useState({
    loading: false,
    message: "",
    error: ""
  });
  // Notes / Images
  const [showOrderModal, setShowOrderModal] = useState(false);
  const [pageImgSms, setPageImgSms] = useState(false);
  const [showOrderNote, setShowOrderNote] = useState(false);
  const [graphicNote, setGraphicNote] = useState("");
  const [graphicNoteBs, setGraphicNoteBs] = useState([]);
  const [graphicImgBs, setGraphicImgBs] = useState([]);
  // Mode de paiement CJ (manuel/automatique) appliqué si ce produit vient de
  // CJ Dropshipping -- voir l'effet ci-dessous, déclenché une fois que
  // `orders.products.sourceType` est connu.
  const [cjPaymentMode, setCjPaymentMode] = useState(null);
  // Order Processing modal's shipping-mode selector
  // (auto/manual/shippo/easypost -- see setOrderShippingMode server-side).
  // Independent of checkoutState/canAcceptCapture: saving a mode never
  // touches payment/capture, mirroring how tracking info is already saved
  // independently of Accept & Capture.
  const [shippingModeState, setShippingModeState] = useState({
    saving: false,
    error: "",
    providers: null
  });
  // Shippo/EasyPost center form's "scan/récupération automatique" step
  // (task spec: try auto-retrieve first, fall back to manual entry --
  // never block the tracking input just because Shippo/EasyPost is
  // selected). Fetched from the order's own recorded provider/tracking
  // via GET /shipping/tracking/order/:oid/:opid (built for the shipping
  // system), not a fresh provider API call every render.
  const [providerTrackingState, setProviderTrackingState] = useState({
    loading: false,
    data: null,
    error: ""
  });

  let orderID = getOrderID.oid;
  let prodIDI = getOrderID.pid;

  const { carrier, tracking, urlTracking, url_label } = info;

  const carriersElakay = ["USPS", "UPS", "FedEx", "DHL eCommerce", "OnTrac"];

  const checkInfoBool =
    carrier !== "" &&
    tracking !== "" &&
    urlTracking !== "" &&
    isValidUrl(urlTracking);

  let StyleMenu0 = {
    borderLeft: "1px solid lightgrey",
    borderRight: "1px solid lightgrey",
    borderBottom: "None",
    backgroundColor: "White",
  };

  let StyleMenu1 = {
    borderLeft: "1px solid lightgrey",
    borderRight: "1px solid lightgrey",
    backgroundColor: "White",
    borderBottom: "6px solid #007399",
  };

  let plsh1 = pageImgSms ? StyleMenu1 : StyleMenu0;
  let plsh2 = !pageImgSms ? StyleMenu1 : StyleMenu0;

  // --- Utils ---------------------------------------------------------

  const sum = (total, num) => total + Math.round(num || 0);

  const objNotEmpty = (obj) => {
    for (var prop in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, prop)) return true;
    }
    return false;
  };

  // --- LOAD DATA -----------------------------------------------------

  const newCartProd = async (data) => {
    for (let i = 0; i < data?.length; i++) {
      const additionalData = await taxProductAreaByState(
        data[i]?.prod_User_Address.country,
        data[i]?.prod_User_Address.postalCode
      );
      if (additionalData) {
        data[i].taxprodZone = additionalData.zoneTax;
      }
    }

    let objOrder = data[0];
    setOrders(objOrder);
    setOrdersShipping(objOrder.shippingAddress);

    loadSimulationPrice(objOrder, 0, 0, 0);
    return objOrder;
  };

  const laodRetrievePayment = (token, IDpaymentMethods) => {
    if (!IDpaymentMethods) return;

    retrievePayment(token, { IDpaymentMethods }).then((data) => {
      if (data.error) {
      } else {
        setOrderPayment({
          PM_id_sel: data?.payment_method?.id,
          b_name: data?.payment_method?.billing_details?.name,
          b_exp_month: data?.payment_method?.card?.exp_month,
          b_exp_year: data?.payment_method?.card?.exp_year,
          b_city: data?.payment_method?.billing_details.address?.city,
          b_brand: data?.payment_method?.card?.brand,
          b_last4: data?.payment_method?.card?.last4,
          b_country: data?.payment_method?.billing_details.address?.country,
          b_line1: data?.payment_method?.billing_details.address?.line1,
          b_postal_code:
            data?.payment_method?.billing_details?.address?.postal_code,
          b_state: data?.payment_method?.billing_details?.address?.state,
        });
      }
    });
  };

  const laodPaymentMethodView = (token, ID) => {
    if (!ID) return;
    getPaymentIntentView(token, ID).then((data) => {
      if (data.error) {
      } else {
        setOrderPayment({
          PM_id_sel: null,
          b_name: null,
          b_exp_month: data?.cardInfo?.exp_month,
          b_exp_year: data?.cardInfo?.exp_year,
          b_city: null,
          b_brand: data?.cardInfo?.brand,
          b_last4: data?.cardInfo?.last4,
          b_country: null,
          b_line1: null,
          b_postal_code: null,
          b_state: null,
        });
      }
    });
  };

  const loadSimulationPrice = (ord, ship, pp, pr) => {
    // Tax / total actually charged: the order's stored snapshot when it has
    // one (never re-derived from today's tax table or the shop's address).
    const snapshot = ord?.products?.payment?.financial;
    const chargedTax = Number.isInteger(snapshot?.taxCents) ? snapshot.taxCents / 100 : null;
    const chargedTotal = Number.isInteger(snapshot?.amountCents) ? snapshot.amountCents / 100 : null;
    let newInf = {
      ItemsOrder: ItemsOrder([ord]),
      prodDiscount: prodDiscount([ord]),
      prodPrice: prodPrice([ord]),
      prodFrService: prodFrService([ord], 0),
      prodFrVente: prodFrVente([ord], 0),
      prodFrRef: prodFrRef([ord], 0),
      TaxOrder: chargedTax ?? TaxOrder([ord]),
      getTotal: chargedTotal ?? getTotal([ord], 0),
      prodFrTransaction: prodFrTransaction([ord], 0),
      totalFrais: totalFrais([ord], 0),
      inComeSeller: inComeSeller([ord], 0),
      elakayFrais: elakayFrais([ord], 0),
      statut: calProfit([ord], ship, pp),
    };
    setSimulationPrice(newInf);
  };

  const loadOrders = async (token, OID, PID) => {
    setLoading(true);
    try {
      const data = await OrdersViewById(token, OID, PID);
      if (data.error) {
        return null;
      }
      // 🐛 FIX: galeries_Prod removed from the orderViewId response (backend
      // payload audit, 2026-09-11) -- this line was already dead on arrival
      // even before that: galeries_Prod was a plain object ({galeries:[...]}),
      // never an array, so indexing it with [0] always silently evaluated to
      // undefined and setGaleries ran unconditionally with []. Now that the
      // field is gone entirely, `data[0]?.galeries_Prod` is undefined and
      // `undefined[0]` throws ("Cannot read properties of undefined (reading
      // '0')") on every order view instead of silently no-oping. Build the
      // gallery from products.urlImg (this order line's own main image,
      // already in this same response) instead -- only one image instead of
      // the full product gallery, but strictly more than the zero this
      // picker ever actually showed before.
      const mainImageUrl = data[0]?.products?.urlImg;
      setGaleries(mainImageUrl ? { galeries: [{ urlImg: mainImageUrl }] } : { galeries: [] });
      const loadedOrder = await newCartProd(data);
      setGraphicNoteBs(data[0]);

      const paymentIntent = data[0]?.products?.paymentIntent;
      if (paymentIntent?.payment_method) {
        laodRetrievePayment(token, paymentIntent.payment_method);
      } else if (data[0]?.products?.transaction_id) {
        laodPaymentMethodView(token, data[0].products.transaction_id);
      }

      if (data[0]?.products?.graphic) {
        getGraphicOrder(token, OID).then((g) => {
          if (g.error) {
          } else {
            setGraphicImgBs(g);
          }
        });
      }

      return loadedOrder;
    } catch (loadError) {
      console.error("Unable to load order:", loadError);
      return null;
    } finally {
      setLoading(false);
    }
  };

  // Identity guard for this exact mount -- NOT a cache, NOT a timer. React 18
  // StrictMode (see src/index.js) deliberately mounts -> cleans up -> remounts
  // every component once in dev, re-running this same effect body twice for
  // the SAME oid/pid with no state in between, which fired OrdersViewById()
  // (GET /user/orderViewId/:oid/:pid) twice for a single "Checkout" click
  // that mounts <Orders> for the first time (buyerOrder.jsx's
  // {showOrderView && <Shipped .../>}). The ref survives StrictMode's fake
  // unmount/remount (same fiber, same ref) but not a real one, so a genuine
  // re-fetch of a different -- or later re-opened -- order is unaffected.
  const loadOrdersRequestedKeyRef = useRef(null);
  useEffect(() => {
    const requestKey = `${token}|${orderID}|${prodIDI}`;
    if (loadOrdersRequestedKeyRef.current === requestKey) return;
    loadOrdersRequestedKeyRef.current = requestKey;
    loadOrders(token, orderID, prodIDI);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token, orderID, prodIDI]);

  // Charge le mode de paiement CJ (manuel/automatique) une fois qu'on sait
  // que ce produit vient de CJ Dropshipping -- inutile d'appeler l'endpoint
  // pour les produits natifs/autres sources. cjRequestKeyRef is the same
  // request-key guard as loadOrders/tracking above: it only blocks a
  // repeat call for the SAME token while isCJDropshippingProduct stays
  // true (StrictMode/re-render noise), and resets the moment it goes
  // false so a genuinely different order/product re-fetches normally.
  const isCJDropshippingProduct = orders?.products?.sourceType === "dropshipping";
  const cjRequestKeyRef = useRef(null);
  useEffect(() => {
    if (!isCJDropshippingProduct || !token) {
      cjRequestKeyRef.current = null;
      return;
    }
    const requestKey = `${orderID}|${prodIDI}|${token}`;
    if (cjRequestKeyRef.current === requestKey) return;
    cjRequestKeyRef.current = requestKey;

    let cancelled = false;
    getCJPaymentMode(token).then((data) => {
      if (!cancelled && !data?.error) setCjPaymentMode(data.settings || null);
    });
    return () => { cancelled = true; };
  }, [isCJDropshippingProduct, token, orderID, prodIDI]);

  // --- Payment tables (mêmes calculs, nouveau design via CSS) --------

  const countProd = [orders]?.map((p) => p?.products?.count || p?.count || 0);
  const countProduct = countProd.reduce(sum, 0);

  const PaymentAchat = () => (
    <table className="ordersview-table-premium">
      <tbody>
        <tr>
          <th>
            {countProduct}{" "}
            {infoSource.laguangeElakay("label", infoSource.languageAPI).items}:
          </th>
          <td>
            {getSimulationPrice.ItemsOrder.toLocaleString("en-US", {
              style: "currency",
              currency: "USD",
            })}
          </td>
        </tr>
        <tr>
          <th>
            {infoSource.laguangeElakay("label", infoSource.languageAPI).shipping}
            :
          </th>
          <td>
            {(0).toLocaleString("en-US", {
              style: "currency",
              currency: "USD",
            })}
          </td>
        </tr>
        <tr>
          <th>
            {infoSource.laguangeElakay("label", infoSource.languageAPI).tax}:
          </th>
          <td>
            {getSimulationPrice.TaxOrder.toLocaleString("en-US", {
              style: "currency",
              currency: "USD",
            })}
          </td>
        </tr>
        <tr className="ordersview-table-row-primary ordersview-table-total">
          <th>
            {infoSource.laguangeElakay("label", infoSource.languageAPI).total}:
          </th>
          <td>
            {getSimulationPrice.getTotal.toLocaleString("en-US", {
              style: "currency",
              currency: "USD",
            })}
          </td>
        </tr>
      </tbody>
    </table>
  );

  const PaymentAchVent = () => (
    <table className="ordersview-table-premium">
      <tbody>
        <tr>
          <th>{infoSource.language(infoSource, "sellPage", "pribefdisc")}:</th>
          <td>
            {getSimulationPrice.prodPrice.toLocaleString("en-US", {
              style: "currency",
              currency: "USD",
            })}
          </td>
        </tr>
        <tr>
          <th>{infoSource.language(infoSource, "sellPage", "prAftDisc")}:</th>
          <td>
            {getSimulationPrice.ItemsOrder.toLocaleString("en-US", {
              style: "currency",
              currency: "USD",
            })}
          </td>
        </tr>
        <tr>
          <th>
            {infoSource.language(infoSource, "sellPage", "discount")}
            {orders.products && orders.products.salePrice}%:
          </th>
          <td>
            {getSimulationPrice.prodDiscount.toLocaleString("en-US", {
              style: "currency",
              currency: "USD",
            })}
          </td>
        </tr>
        <tr>
          <th>
            {infoSource.laguangeElakay("label", infoSource.languageAPI).shipping}
            :
          </th>
          <td>
            {(0).toLocaleString("en-US", {
              style: "currency",
              currency: "USD",
            })}
          </td>
        </tr>
        <tr>
          <th>
            {infoSource.laguangeElakay("label", infoSource.languageAPI).tax}:
          </th>
          <td>
            {getSimulationPrice.TaxOrder.toLocaleString("en-US", {
              style: "currency",
              currency: "USD",
            })}
          </td>
        </tr>
        <tr className="ordersview-table-row-primary ordersview-table-total">
          <th>
            {infoSource.laguangeElakay("label", infoSource.languageAPI).total}:
          </th>
          <td>
            {getSimulationPrice.getTotal.toLocaleString("en-US", {
              style: "currency",
              currency: "USD",
            })}
          </td>
        </tr>
        <tr>
          <th>{infoSource.language(infoSource, "sellPage", "fraiPaiem")}:</th>
          <td>
            {getSimulationPrice.prodFrTransaction.toLocaleString("en-US", {
              style: "currency",
              currency: "USD",
            })}
          </td>
        </tr>
        <tr>
          <th>{__elakayText("t007", "elakay Feet 6% + $")}{parseFloat(clotureFeet).toFixed(2)}:</th>
          <td>
            {getSimulationPrice.elakayFrais.toLocaleString("en-US", {
              style: "currency",
              currency: "USD",
            })}
          </td>
        </tr>
        <tr className="ordersview-table-row-secondary ordersview-table-total">
          <th>{infoSource.language(infoSource, "sellPage", "TotFrais")}:</th>
          <td>
            {getSimulationPrice.totalFrais.toLocaleString("en-US", {
              style: "currency",
              currency: "USD",
            })}
          </td>
        </tr>
        <tr className="ordersview-table-row-success ordersview-table-total">
          <th>{infoSource.language(infoSource, "sellPage", "revNet")}:</th>
          <td>
            {getSimulationPrice.inComeSeller.toLocaleString("en-US", {
              style: "currency",
              currency: "USD",
            })}
          </td>
        </tr>
      </tbody>
    </table>
  );

  const PaymentVente = () => (
    <table className="ordersview-table-premium">
      <tbody>
        <tr>
          <th>
            {1}{" "}
            {infoSource.laguangeElakay("label", infoSource.languageAPI).items}:
          </th>
          <td>
            {getSimulationPrice.prodPrice.toLocaleString("en-US", {
              style: "currency",
              currency: "USD",
            })}
          </td>
        </tr>
        <tr>
          <th>
            {infoSource.laguangeElakay("label", infoSource.languageAPI).shipping}
            :
          </th>
          <td>
            {(0).toLocaleString("en-US", {
              style: "currency",
              currency: "USD",
            })}
          </td>
        </tr>
        <tr>
          <th>
            {infoSource.laguangeElakay("label", infoSource.languageAPI).tax}:
          </th>
          <td>
            {getSimulationPrice.TaxOrder.toLocaleString("en-US", {
              style: "currency",
              currency: "USD",
            })}
          </td>
        </tr>
        <tr>
          <th>{infoSource.language(infoSource, "sellPage", "discount")}:</th>
          <td>
            {getSimulationPrice.prodDiscount.toLocaleString("en-US", {
              style: "currency",
              currency: "USD",
            })}
          </td>
        </tr>
        <tr>
          <th>{infoSource.language(infoSource, "sellPage", "fraisServi")}:</th>
          <td>
            {getSimulationPrice.prodFrService.toLocaleString("en-US", {
              style: "currency",
              currency: "USD",
            })}
          </td>
        </tr>
        <tr>
          <th>{infoSource.language(infoSource, "sellPage", "fraispaie")}:</th>
          <td>
            {getSimulationPrice.prodFrTransaction.toLocaleString("en-US", {
              style: "currency",
              currency: "USD",
            })}
          </td>
        </tr>
        <tr>
          <th>{infoSource.language(infoSource, "sellPage", "fraiVente")}:</th>
          <td>
            {getSimulationPrice.prodFrVente.toLocaleString("en-US", {
              style: "currency",
              currency: "USD",
            })}
          </td>
        </tr>
        <tr>
          <th>{infoSource.language(infoSource, "sellPage", "frGesExpedi")}:</th>
          <td>
            {(0).toLocaleString("en-US", {
              style: "currency",
              currency: "USD",
            })}
          </td>
        </tr>
        <tr>
          <th>{infoSource.language(infoSource, "sellPage", "fraiReferen")}:</th>
          <td>
            {getSimulationPrice.prodFrRef.toLocaleString("en-US", {
              style: "currency",
              currency: "USD",
            })}
          </td>
        </tr>
        <tr>
          <th>{infoSource.language(infoSource, "sellPage", "fraisClotu")}:</th>
          <td>
            {clotureFeet.toLocaleString("en-US", {
              style: "currency",
              currency: "USD",
            })}
          </td>
        </tr>
        <tr className="ordersview-table-row-secondary ordersview-table-total">
          <th>{infoSource.language(infoSource, "sellPage", "TotFrais")}:</th>
          <td>
            {getSimulationPrice.totalFrais.toLocaleString("en-US", {
              style: "currency",
              currency: "USD",
            })}
          </td>
        </tr>
        <tr className="ordersview-table-row-success ordersview-table-total">
          <th>{infoSource.language(infoSource, "sellPage", "revNet")}:</th>
          <td>
            {getSimulationPrice.inComeSeller.toLocaleString("en-US", {
              style: "currency",
              currency: "USD",
            })}
          </td>
        </tr>
      </tbody>
    </table>
  );

  // --- Vues ----------------------------------------------------------

  const ProductView = () => (
    <div className="ordersview-product-card">
      <h3 className="ordersview-product-title">
        {/* {orders.prod_name} */}
        <infoSource.TruncatedText text={orders.prod_name} limits={[40, 30]} showToggle = {true}/>
        </h3>

      <div className="ordersview-timestamp-badge">
        {orders.createdAt && moment(orders.createdAt).fromNow()}
      </div>

      <div className="ordersview-product-view">
        <div className="ordersview-product-image-container">
          {orders && orders.products && (
            <ShowimagesLoading
              className="ordersview-product-image"
              src={orders.products.urlImg}
              onError={(event) => {
                event.target.src = imgProductLakay;
                event.onerror = null;
              }}
              alt={orders.prod_name}
            />
          )}
        </div>

        <div className="ordersview-product-info">
          <p className="ordersview-product-description">
            {/* {orders.prod_Description} */}
             <infoSource.TruncatedText text={orders.prod_Description} limits={[70, 50]} showToggle = {true}/>
          </p>
          {orders &&
            orders.prod_filterProduct &&
            orders.prod_filterProduct.filter && (
              <Filters filter={filterProductSel(orders)} nexLine={true} />
            )}
        </div>
      </div>
    </div>
  );

  const textButtonProcess = (status) => {
    if (status === "Not processed") {
      return infoSource.language(infoSource, "Button", "startProcessing");
    } else if (status === "Processing") {
      return infoSource.language(infoSource, "Button", "finishProcessing");
    } else {
      return infoSource.language(infoSource, "Button", "viewProcessing");
    }
  };

  // Bug: "Update Shipping stays disabled even though carrier/tracking/URL
  // are already saved in the database." Root cause -- this form only ever
  // read product.info.{carrier,tracking,urlTracking} (the legacy fields
  // updateOrder/clickBtnInfo write to). Shippo/EasyPost/manual saves made
  // through the newer shipping system (elakay_services/shipping/,
  // POST /shipping/manual, provider webhooks/sync) land primarily on
  // product.delivery.{carrierName,carrierCode,trackingNumber,trackingUrl}
  // -- which can be populated while product.info stays empty. checkInfoBool
  // then reads empty local `info` state and disables the button even
  // though the order genuinely already has shipping data. Fall back to
  // delivery.* here, same "delivery first" precedence resolveTrackingUrl
  // already uses for the URL specifically -- now applied to carrier and
  // tracking number too.
  const addTrackNumberBtn = () => {
    if (readOnly) return;
    const existingInfo = orders?.products?.info || {};
    const delivery = orders?.products?.delivery || {};
    const carrier = existingInfo.carrier || delivery.carrierName || delivery.carrierCode || "";
    const tracking = existingInfo.tracking || delivery.trackingNumber || "";
    setInfo({
      carrier,
      tracking,
      urlTracking: resolveTrackingUrl(orders, carrier, tracking, existingInfo.urlTracking),
      url_label: existingInfo.url_label || ""
    });
    setCheckoutState({ loading: false, message: "", error: "" });
    setShowTracking(true);
  };

  const handleOrder = (name) => (event) => {
    const value = event.target.value;
    setInfo((current) => {
      if (name === "carrier") {
        return {
          ...current,
          carrier: value,
          urlTracking: resolveTrackingUrl(orders, value, current.tracking, current.urlTracking)
        };
      }
      return { ...current, [name]: value };
    });
  };

  // ══════════════════════════════════════════════════════════════════════
  // PAYMENT and SHIPPING are two completely separate workflows (task
  // spec §26 "PAYMENT ≠ SHIPPING. Do not couple them"). Neither one's
  // functions/state may block or require the other:
  //   - clickBtnAccept/clickBtnReject touch ONLY payment (Stripe capture,
  //     via POST /order/:oid/:opid/accept|reject) and use checkoutState.
  //   - clickBtnInfo touches ONLY shipping (PUT /order/update/:oid/:opid,
  //     no Stripe call at all -- see the historical note below) and uses
  //     its own shippingSaveState.
  // Accepting a payment never requires carrier/tracking/URL to be filled
  // in, and saving shipping info never touches payment/capture.
  // ══════════════════════════════════════════════════════════════════════

  // Persistance des infos de tracking uniquement -- ne capture plus aucun
  // paiement. Auparavant cette fonction envoyait aussi
  // payment:{amount,customer,payment_method} et PUT /order/update/:oid/:opid
  // s'en servait pour déclencher la charge Stripe ; depuis la refonte
  // paiement en deux étapes, cette route ne fait plus aucun appel Stripe
  // (et la vieille branche paymentIntent qui le permettait encore a été
  // retirée côté backend), la capture vit exclusivement dans
  // POST /order/:oid/:opid/accept.
  const persistTrackingInfo = async () => {
    if (fulfillmentReadOnly) return { ok: false, error: ot("providerReadOnly") };
    const normalizedTracking = trackingFromBarcode(info.tracking);

    if (!info.carrier || !normalizedTracking) {
      return {
        ok: false,
        error: elakayAutoText("h_812c3272d4a65a", "Transporteur, tracking et URL de suivi valides sont requis.")
      };
    }

    const freshOrder = await loadOrders(token, orderID, prodIDI);
    if (!freshOrder?.products) {
      return { ok: false, error: elakayAutoText("h_4922e10875b2f1", "Impossible de charger la commande.") };
    }

    const submissionInfo = {
      ...info,
      tracking: normalizedTracking,
      urlTracking: resolveTrackingUrl(freshOrder, info.carrier, normalizedTracking, info.urlTracking)
    };

    if (!submissionInfo.urlTracking || !isValidUrl(submissionInfo.urlTracking)) {
      return {
        ok: false,
        error: elakayAutoText("h_812c3272d4a65a", "Transporteur, tracking et URL de suivi valides sont requis.")
      };
    }

    setInfo(submissionInfo);
    const data = await updateOrder(token, getOrderID, {
      orders: { info: submissionInfo },
    });

    if (data.error) {
      return {
        ok: false,
        error: data.error || elakayAutoText("h_812c3272d4a65a", "Impossible d'enregistrer le suivi.")
      };
    }

    setInfo(infoValue);
    return { ok: true };
  };

  // "Update Shipping" -- the ONLY action that saves carrier/tracking/URL.
  // Works identically whether payment has been captured yet or not (task
  // spec §4/§10: both "shipping first, then payment" and "payment first,
  // tracking added later" must work), and never touches payment/capture.
  // Does NOT close the modal -- the seller may still have payment or
  // other shipping fields to handle.
  const clickBtnInfo = async () => {
    if (shippingSaveState.loading || shippingModeState.saving) return;
    setShippingSaveState({ loading: true, message: "", error: "" });

    const result = await persistTrackingInfo();
    if (!result.ok) {
      setShippingSaveState({ loading: false, message: "", error: result.error });
      return;
    }

    await loadOrders(token, orderID, prodIDI);
    setShippingSaveState({
      loading: false,
      message: elakayAutoText("h_f1aa707455d599", "Suivi enregistré et commande rechargée."),
      error: ""
    });
  };

  // --- Paiement en deux étapes : accepter (capture) / refuser (annule) ---
  // canAcceptCapture is driven ENTIRELY by payment/order state (backend
  // truth, reloaded via loadOrders -- never a frontend-only flag), never
  // by shipping fields. Once payment.status becomes "captured" (backend-
  // confirmed, survives refresh/reopen/another device), this is false and
  // stays false -- the payment action is gone for good, exactly as
  // task spec §3 requires.
  const payment = orders?.products?.payment || {};
  const sellerDecision = orders?.products?.sellerDecision || {};
  const captureDeadline = payment.captureDeadline ? new Date(payment.captureDeadline) : null;
  const captureDeadlinePassed = Boolean(captureDeadline && new Date() > captureDeadline);
  const canDecideOrder =
    !readOnly && sellerAcceptsPayment(orders?.products)
    && orders?.products?.status === "Not processed"
    && (!sellerDecision.status || sellerDecision.status === "pending")
    && !payment.lifecycle?.shippingBlocked && !["open", "lost"].includes(payment.disputeStatus)
    && !captureDeadlinePassed;
  // The buyer authorized the payment at checkout: accepting a `not_started`
  // line authorizes and captures the card stored on it (server side, see
  // orderDecisionPayment.prepareAcceptance). Only a line that really carries
  // no buyer authorization waits for the buyer: a card order saved without a
  // card, or a PayPal order never approved (the server refuses both).
  const buyerPaymentMissing = canDecideOrder && payment.status === "not_started"
    && (payment.provider === "paypal" || !orders?.products?.paymentIntent?.payment_method);
  const canAcceptCapture = canDecideOrder && !buyerPaymentMissing
    && ["authorized", "capture_failed", "not_started", "requires_action"].includes(payment.status)
    && (payment.status !== "not_started" || orders?.products?.orderManagement?.version === 1);

  // "Accept Order & Capture Payment" -- PAYMENT ONLY. Deliberately does
  // NOT call persistTrackingInfo/require any shipping field (task spec
  // §1/§2/§12): a seller must be able to accept and capture immediately,
  // with shipping information completed later via clickBtnInfo above.
  // captureAuthorizedPayment on the backend is itself idempotent (checks
  // pay.status === "captured" and short-circuits) -- this frontend guard
  // (checkoutState.loading + canAcceptCapture, itself driven by the
  // backend-confirmed payment status) is defense-in-depth, not the only
  // protection against a double capture.
  const clickBtnAccept = async () => {
    if (checkoutState.loading || !canAcceptCapture) return;
    if (!window.confirm(elakayAutoText(
      "h_accept_capture_confirm",
      "En acceptant cette commande, le paiement autorisé du client sera capturé et la commande sera envoyée au processus de traitement."
    ))) return;

    setCheckoutState({ loading: true, message: "", error: "" });
    const data = await acceptOrder(token, getOrderID);

    if (data.error) {
      setCheckoutState({
        loading: false,
        message: "",
        error: data.error || elakayAutoText("h_accept_capture_error", "La capture du paiement a échoué.")
      });
      return;
    }

    await loadOrders(token, orderID, prodIDI);
    setCheckoutState({
      loading: false,
      message: data.status === "capture_pending" ? elakayAutoText("h_pay_pending", "Payment is awaiting provider confirmation. Check your order before retrying.") : elakayAutoText("h_accept_capture_success", "Paiement capturé, commande en traitement."),
      error: ""
    });
    await onUpdated?.();
  };

  const clickBtnReject = async () => {
    if (checkoutState.loading || !canDecideOrder) return;
    const reason = window.prompt(elakayAutoText("h_reject_reason_prompt", "Raison du refus (optionnel) :")) || "";

    setCheckoutState({ loading: true, message: "", error: "" });
    const data = await rejectOrder(token, getOrderID, { reason });

    if (data.error) {
      setCheckoutState({
        loading: false,
        message: "",
        error: data.error || elakayAutoText("h_reject_error", "Le refus de la commande a échoué.")
      });
      return;
    }

    await loadOrders(token, orderID, prodIDI);
    setCheckoutState({
      loading: false,
      message: elakayAutoText("h_reject_success", "Commande refusée, autorisation annulée."),
      error: ""
    });
    await onUpdated?.();
  };

  // Order Processing modal's shipping-mode selector. Loaded once the
  // modal can actually be shown -- the same sanitized status Family/Seller
  // dashboards already use (GET /shipping/providers, no secrets) tells us
  // which of Auto/Manual/Shippo/EasyPost are actually selectable right now.
  useEffect(() => {
    if (!showTracking || fulfillmentReadOnly || !token || shippingModeState.providers) return;
    getShippingProviderStatus(token)
      .then((data) => setShippingModeState((current) => ({ ...current, providers: data })))
      .catch(() => undefined);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [showTracking, fulfillmentReadOnly, token]);

  const currentShippingMode = orders?.products?.shippingMode || "manual";
  const isDropshippingItem = orders?.products?.sourceType === "dropshipping";

  const selectShippingMode = async (mode) => {
    if (shippingModeState.saving || mode === currentShippingMode) return;
    setShippingModeState((current) => ({ ...current, saving: true, error: "" }));
    const data = await updateOrderShippingMode(token, getOrderID.oid, getOrderID.opid, mode);
    if (data?.error) {
      setShippingModeState((current) => ({
        ...current,
        saving: false,
        error: data.error || elakayAutoText("h_shipping_mode_save_error", "Impossible d'enregistrer ce mode d'expédition.")
      }));
      return;
    }
    await loadOrders(token, orderID, prodIDI);
    setShippingModeState((current) => ({ ...current, saving: false, error: "" }));
  };

  // Shippo/EasyPost center form: try to auto-retrieve an existing
  // shipment's tracking the moment that mode is selected/shown, instead
  // of always starting from a blank manual-entry form (task spec: "scan/
  // récupération automatique OU saisie manuelle"). A 404/no-shipment-yet
  // response is expected and not treated as an error -- it just means the
  // manual fallback fields below stay empty and editable.
  //
  // trackingRequestRef is a request-KEY guard, not a permanent "already
  // loaded" flag: it only skips a call that would repeat the exact same
  // (oid, opid, mode) while the modal stays open (StrictMode's dev-only
  // double-mount, or an unrelated re-render), and is cleared the moment
  // showTracking goes false so reopening the modal -- or genuinely
  // switching order/product/mode -- always fetches fresh.
  const trackingRequestKeyRef = useRef(null);
  useEffect(() => {
    if (!showTracking || fulfillmentReadOnly || !token) {
      trackingRequestKeyRef.current = null;
      return;
    }
    if (currentShippingMode !== "shippo" && currentShippingMode !== "easypost") return;

    const requestKey = `${getOrderID.oid}|${getOrderID.opid}|${currentShippingMode}`;
    if (trackingRequestKeyRef.current === requestKey) return;
    trackingRequestKeyRef.current = requestKey;

    let cancelled = false;
    setProviderTrackingState({ loading: true, data: null, error: "" });
    getOrderTracking(token, getOrderID.oid, getOrderID.opid)
      .then((data) => {
        if (cancelled) return;
        if (data?.error) {
          setProviderTrackingState({ loading: false, data: null, error: "" });
          return;
        }
        setProviderTrackingState({ loading: false, data, error: "" });
      })
      .catch(() => {
        if (!cancelled) setProviderTrackingState({ loading: false, data: null, error: "" });
      });
    return () => { cancelled = true; };
  }, [showTracking, fulfillmentReadOnly, token, currentShippingMode, getOrderID.oid, getOrderID.opid]);

  const onChangeLabel_tack = (btn) => {
    if (btn === "View Tracking") {
      label_Tracking[0]
        ? setLabel_Tracking([false, false])
        : setLabel_Tracking([true, false]);
    }
    if (btn === "View Label") {
      label_Tracking[1]
        ? setLabel_Tracking([false, false])
        : setLabel_Tracking([false, true]);
    }
  };

  const stepPageMessage = () => (
    <div className="row justify-content-center">
      <div className="col-xs-12">
        <div className="col-12 col-md-12" style={{ textAlign: "center" }}>
          <div className="row">
            <div
              className="col col-6"
              style={plsh2}
              onClick={() => setPageImgSms(false)}
            >{__elakayText("t011", "Message")}</div>
            <div
              className="col col-6"
              style={plsh1}
              onClick={() => setPageImgSms(true)}
            >{__elakayText("t012", "Images")}</div>
          </div>
        </div>
      </div>
    </div>
  );

  const viewOrderNoteMessage = () => (
    <Modal
      size="md"
      show={showOrderNote}
      onHide={() => setShowOrderNote(false)}
      dialogClassName="modal-90w"
      aria-labelledby="example-custom-modal-styling-title"
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title id="example-custom-modal-styling-title">
          {stepPageMessage()}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <OrderNoteMessage
          orderID={getOrderID.oid}
          token={token}
          pageImgSms={pageImgSms}
          infoSource={infoSource}
          setGraphicNote={setGraphicNote}
          graphicNote={graphicNote}
          graphicNoteBs={graphicNoteBs}
          setGraphicNoteBs={setGraphicNoteBs}
          graphicImgBs={graphicImgBs}
          ust="s"
          userSend="seller"
        />
      </Modal.Body>
    </Modal>
  );

  // Order Processing modal (opened by "Start Processing"/"Finish Processing"
  // /"View Processing" -- textButtonProcess()). Fixed layout, top to
  // bottom: shippingModeSelectorTop() -> a mode-dependent center form
  // (autoModeCenterPanel / manualShippingCenterForm / providerScanCenterForm)
  // -> processingActionsBottom(). All reuse their existing functions
  // unchanged (clickBtnAccept/clickBtnReject/setShowOrderModal/clickBtnInfo).
  const shippingModeSelectorTop = () => {
    const providers = shippingModeState.providers;
    const allowedProviders = providers?.allowedProviders || [];
    const modeOption = (mode, label) => {
      // "shippo"/"easypost" are only offered once Family has enabled AND
      // configured that provider (task spec: "the frontend only displays
      // choices the backend says are available"); Auto/Manual are always
      // offerable -- Auto's own resolution still enforces the same rule
      // server-side.
      const disabled =
        (mode === "shippo" && !allowedProviders.includes("SHIPPO")) ||
        (mode === "easypost" && !allowedProviders.includes("EASYPOST"));
      const active = currentShippingMode === mode;
      return (
        <button
          key={mode}
          type="button"
          disabled={disabled || shippingModeState.saving}
          onClick={() => selectShippingMode(mode)}
          className={`ordersview-btn-premium ${active ? "ordersview-btn-outline-dark" : ""}`}
          style={{
            flex: "1 1 120px",
            opacity: disabled ? 0.45 : 1,
            fontWeight: active ? 800 : 400,
            border: active ? "2px solid #087F8C" : "1px solid #ccc"
          }}
          title={disabled ? elakayAutoText("h_shipping_mode_unavailable", "Non disponible -- désactivé par Elakay ou non configuré.") : ""}
        >
          {active ? "✓ " : ""}{label}
        </button>
      );
    };

    return (
      <div className="ordersview-section-card" style={{ marginBottom: 16 }}>
        <h5 className="ordersview-section-title">
          {elakayAutoText("h_shipping_mode_title", "Mode d'expédition")}
        </h5>

        {isDropshippingItem ? (
          <div className="ordersview-payment-authorized-banner">
            <p>{elakayAutoText(
              "h_shipping_mode_dropshipping_locked",
              "Cette commande est traitée via le fournisseur dropshipping déjà identifié pour cet article. Le mode d'expédition ne peut pas être changé ici."
            )}</p>
          </div>
        ) : (
          <>
            <div style={{ display: "flex", flexWrap: "wrap", gap: 8, marginBottom: 8 }}>
              {modeOption("auto", elakayAutoText("h_shipping_mode_auto", "Auto"))}
              {modeOption("manual", elakayAutoText("h_shipping_mode_manual", "Manuel"))}
              {modeOption("shippo", "Shippo")}
              {modeOption("easypost", "EasyPost")}
            </div>
            {shippingModeState.error && (
              <div className="ordersview-payment-feedback is-error">{shippingModeState.error}</div>
            )}
          </>
        )}
      </div>
    );
  };

  // AUTO (and dropshipping, which forces shippingMode="dropshipping" and
  // locks the selector -- see shippingModeSelectorTop) center panel:
  // detection info first, "ne pas demander inutilement au seller de
  // remplir les informations déjà connues." The manual fields are still
  // reachable underneath purely as an optional override/supplement (the
  // seller may want to add/correct tracking manually even for an
  // auto-detected shipment) -- they are NEVER required to accept payment
  // (task spec §1/§2/§12: shipping fields must never gate payment
  // capture; "Update Shipping" below is a fully independent action).
  const autoModeCenterPanel = () => (
    <>
      <div className="ordersview-section-card" style={{ marginBottom: 16 }}>
        <h5 className="ordersview-section-title">
          {elakayAutoText("h_shipping_auto_panel_title", "Détection automatique")}
        </h5>
        {isCJDropshippingProduct ? (
          <p>
            {elakayAutoText(
              "h_shipping_auto_panel_dropshipping",
              "Commande dropshipping identifiée -- Elakay utilise automatiquement le fournisseur déjà associé à cet article (CJ Dropshipping)."
            )}{" "}
            {cjPaymentMode && (
              <strong>
                {cjPaymentMode.paymentMode === "automatic"
                  ? elakayAutoText("h_cj_order_payment_mode_automatic", "Automatique")
                  : elakayAutoText("h_cj_order_payment_mode_manual", "Manuel")}
              </strong>
            )}
          </p>
        ) : (
          <p>
            {elakayAutoText(
              "h_shipping_auto_panel_carrier",
              "Elakay choisit automatiquement le fournisseur d'expédition configuré pour votre boutique."
            )}{" "}
            {orders?.products?.delivery?.provider && (
              <strong>{orders.products.delivery.provider}</strong>
            )}
          </p>
        )}
        <p>{elakayAutoText(
          "h_shipping_auto_panel_tracking_optional",
          "Transporteur, numéro et URL de suivi restent modifiables ci-dessous à tout moment -- ils ne sont jamais requis pour accepter la commande et capturer le paiement."
        )}</p>
      </div>
      {manualShippingCenterForm()}
    </>
  );

  // PAYMENT section: entirely gated by payment/order state
  // (canAcceptCapture, payment.status) -- never by shipping fields (task
  // spec §12 "DO NOT CONFUSE SHIPPING STATE WITH PAYMENT STATE"). Once
  // payment.status is "captured" (backend-confirmed), this permanently
  // shows a completed indicator instead of the action -- survives
  // refresh/reopen/another device because it's driven by data reloaded
  // from the server, never a frontend-only flag (task spec §3).
  const paymentActionsSection = () => (
    <div className="ordersview-section-card" style={{ marginTop: 16 }}>
      <h5 className="ordersview-section-title">
        {elakayAutoText("h_payment_section_title", "Paiement")}
      </h5>

      <OrderPendingTimer line={orders?.products} />
      {payment.status === "captured" ? (
        <div className="ordersview-payment-feedback is-success">
          {elakayAutoText("h_payment_captured_indicator", "✅ Paiement capturé")}
        </div>
      ) : !sellerAcceptsPayment(orders?.products) && ["authorized", "capture_failed", "not_started", "requires_action"].includes(payment.status) ? (
        <p role="status">{elakayAutoText("h_payment_delegated_provider", "The Provider accepts and captures this payment on your behalf. You can follow its status here.")}</p>
      ) : buyerPaymentMissing ? (
        <div className="ordersview-payment-authorized-banner" style={{ width: "100%" }}>
          <div className="ordersview-payment-feedback is-warning" role="status">
            {elakayAutoText("h_payment_waiting_buyer_confirmation", "Waiting for the buyer to select and confirm a payment method.")}
          </div>
          <div style={{ overflow: "hidden", marginBottom: 8 }}>
            <button type="button" className="ordersview-btn-premium" style={{ width: "100%" }} disabled>
              {elakayAutoText("h_accept_capture_btn", "Accept the order and capture payment")}
            </button>
          </div>
          <button onClick={clickBtnReject} disabled={checkoutState.loading} className="ordersview-btn-premium ordersview-btn-cancelled" style={{ width: "100%" }}>
            {elakayAutoText("h_reject_order_btn", "Refuse the order")}
          </button>
        </div>
      ) : canAcceptCapture ? (
        <div className="ordersview-payment-authorized-banner" style={{ width: "100%" }}>
          <p>{payment.status === "not_started" ? orderText("created") : elakayAutoText(
            "h_payment_authorized_notice",
            "Le client a autorisé le paiement. Le montant n'a pas encore été capturé. Vous devez accepter cette commande avant la date limite affichée."
          )}</p>
          {isCJDropshippingProduct && (
            <p style={{
              display: "inline-block",
              padding: "4px 10px",
              borderRadius: 999,
              fontSize: 12,
              fontWeight: 800,
              marginBottom: 8,
              background: cjPaymentMode?.paymentMode === "automatic" ? "#e8f8f0" : "#e7f4f6",
              color: cjPaymentMode?.paymentMode === "automatic" ? "#16784d" : "#00667a",
            }}>
              {elakayAutoText("h_cj_order_payment_mode_label", "Paiement CJ Dropshipping")}:{" "}
              {!cjPaymentMode
                ? elakayAutoText("h_cj_order_payment_mode_loading", "chargement...")
                : cjPaymentMode.paymentMode === "automatic"
                  ? elakayAutoText("h_cj_order_payment_mode_automatic", "Automatique")
                  : elakayAutoText("h_cj_order_payment_mode_manual", "Manuel")}
            </p>
          )}
          {captureDeadline && (
            <p>
              {elakayAutoText("h_capture_deadline_label", "Date limite pour accepter :")}{" "}
              {captureDeadline.toLocaleString()}
            </p>
          )}
          {checkoutState.error && (
            <div className="ordersview-payment-feedback is-error">{checkoutState.error}</div>
          )}

          {/* Accepting payment never requires shipping fields. */}
          <div style={{ overflow: "hidden", marginBottom: 8 }}>
            <button
              type="button"
              className="ordersview-btn-premium"
              style={{ width: "100%", background: "linear-gradient(135deg, #007399, #00a4d8)", color: "#fff" }}
              disabled={checkoutState.loading || !canAcceptCapture}
              onClick={clickBtnAccept}
            >
              {checkoutState.loading
                ? elakayAutoText("h_capture_in_progress", "Capture du paiement en cours...")
                : elakayAutoText("h_accept_capture_btn", "Accepter la commande et capturer le paiement")}
            </button>
          </div>

          <button
            onClick={clickBtnReject}
            disabled={checkoutState.loading || !canAcceptCapture}
            className="ordersview-btn-premium ordersview-btn-cancelled"
            style={{ width: "100%" }}
          >
            {elakayAutoText("h_reject_order_btn", "Refuser la commande")}
          </button>
        </div>
      ) : (
        sellerDecision.status && sellerDecision.status !== "pending" && (
          <p>
            {elakayAutoText("h_payment_decision_status_label", "Statut de la décision vendeur :")}{" "}
            <strong>{sellerDecision.status}</strong>
          </p>
        )
      )}
    </div>
  );

  // SHIPPING section: ALWAYS available, regardless of payment status
  // (task spec §4 "Shipping must remain editable after payment" -- both
  // "shipping first, payment after" and "payment first, tracking added
  // later" must work). Uses shippingSaveState, never checkoutState, so a
  // shipping save in flight can never disable/gate the payment action
  // and vice versa. "Update Shipping" only validates the shipping fields
  // themselves (checkInfoBool) -- never payment state.
  const shippingActionsSection = () => (
    <div className="ordersview-section-card" style={{ marginTop: 16 }}>
      <h5 className="ordersview-section-title">
        {elakayAutoText("h_shipping_actions_title", "Shipping")}
      </h5>
      {shippingSaveState.message && (
        <div className="ordersview-payment-feedback is-success">{shippingSaveState.message}</div>
      )}
      {shippingSaveState.error && (
        <div className="ordersview-payment-feedback is-error">{shippingSaveState.error}</div>
      )}
      <div style={{ display: "flex", alignItems: "center", gap: 12, flexWrap: "wrap" }}>
        <button
          onClick={() => setShowTracking(false)}
          className="ordersview-btn-premium ordersview-btn-outline-dark"
          style={{ flex: "0 0 auto" }}
        >
          {infoSource.language(infoSource, "Button", "cancel")}
        </button>

        <div style={{ overflow: "hidden", flex: "1 1 200px" }}>
          <SubmitCancelButtonSlider
            disabledHint={infoSource.language(infoSource, "text", "textsubcanbuttsli")}
            submit={shippingSaveState.loading
              ? elakayAutoText("h_shipping_save_in_progress", "Enregistrement du suivi en cours...")
              : elakayAutoText("h_update_shipping_btn", "Update Shipping")}
            cancel={infoSource.language(infoSource, "title", "checkout") + "..."}
            isDisabled={shippingSaveState.loading || shippingModeState.saving || !checkInfoBool}
            coldisplay={"#87CEEB"}
            width="100%"
            submitfunction={clickBtnInfo}
          />
        </div>
      </div>
    </div>
  );

  // Payment and shipping render as two visually separate cards (task
  // spec §15 "Payment/order actions remain visually separated") -- never
  // one conditionally replacing the other.
  const processingActionsBottom = () => (
    <>
      <OrderFinancialActions order={orders} line={orders.products} onChanged={async () => { await loadOrders(token, orderID, prodIDI); await onUpdated?.(); }} />
      {paymentActionsSection()}
      {!fulfillmentReadOnly && shippingActionsSection()}
    </>
  );

  // MANUAL center form -- unchanged fields/logic, only extracted into its
  // own function so it can be reused verbatim both for shippingMode
  // "manual" and as the Shippo/EasyPost fallback (task spec: "le tracking
  // input ne doit pas être bloqué simplement parce que Shippo ou EasyPost
  // est sélectionné").
  const manualShippingCenterForm = () => {
    const text1 = infoSource.language(infoSource, "text", "textOrderByuer");
    const textLess1 = infoSource.language(infoSource, "text", "textOrderByuerLess");

    return (
      <>
        <ReadMoreLess infoSource={infoSource} text={text1} textLess={textLess1} />

        <div>
          <div className="form-group">
            <label className="text-muted">
              {infoSource.language(infoSource, "label", "selectCarrier")}
            </label>
            <select
              onChange={handleOrder("carrier")}
              className="form-control"
              value={carrier}
            >
              <option value={""}>
                {
                  infoSource.laguangeElakay(
                    "label",
                    infoSource.languageAPI
                  ).pleaseSelect
                }
              </option>
              {carriersElakay?.map((car, i) => (
                <option key={i} value={car}>
                  {car}
                </option>
              ))}
            </select>
          </div>

          <TrackingCapture
            compact
            value={tracking}
            onChange={(value) => setInfo((current) => ({
              ...current,
              tracking: value,
              urlTracking: resolveTrackingUrl(orders, current.carrier, value, current.urlTracking)
            }))}
            autoSubmitOnScan={false}
            showSubmit={false}
            title={infoSource.language(infoSource, "label", "enterTrackNumber") || elakayAutoText("h_82fa7c67bc59c4", "Tracking de la commande")}
          />
          <div className="ordersview-submit-note">{elakayAutoText("h_b24095bc553de0", "Le scan remplit seulement le tracking. Le paiement commence uniquement avec le bouton Submit.")}</div>

          <div className="form-group">
            <label className="text-muted">
              {infoSource.language(infoSource, "label", "enterUrlTracking")}
            </label>
            <input
              onChange={handleOrder("urlTracking")}
              type="url"
              className={`form-control ${
                urlTracking !== "" && !isValidUrl(urlTracking)
                  ? "is-invalid"
                  : ""
              }`}
              value={urlTracking}
            />
            {urlTracking !== "" && !isValidUrl(urlTracking) && (
              <div className="invalid-feedback">{infoSource.laguangeElakay("frontElakayHardcodedText", infoSource.languageAPI).orderShipped.t002}</div>
            )}
          </div>

          <div className="form-group">
            <label className="text-muted">
              {infoSource.language(infoSource, "label", "enterUrlLabelImages")}
            </label>
            <input
              onChange={handleOrder("url_label")}
              type="url"
              className={`form-control ${
                url_label !== "" && !isValidUrl(url_label)
                  ? "is-invalid"
                  : ""
              }`}
              value={url_label}
            />
            {url_label !== "" && !isValidUrl(url_label) && (
              <div className="invalid-feedback">{infoSource.laguangeElakay("frontElakayHardcodedText", infoSource.languageAPI).orderShipped.t003}</div>
            )}
          </div>

          <style>
            {`
              .is-invalid {
                border-color: #dc3545 !important;
                box-shadow: 0 0 4px rgba(220, 53, 69, 0.4);
              }
              .invalid-feedback {
                color: #dc3545;
                font-size: 0.9rem;
                margin-top: 4px;
              }
            `}
          </style>
        </div>

        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "20px",
            margin: "20px 0",
          }}
        >
          <div>
            <input
              onChange={() => onChangeLabel_tack("View Label")}
              type="checkbox"
              id={"view_label"}
              className="form-check-input check2"
              checked={label_Tracking[1] ? "checked" : ""}
            />
            <label className="form-check-label ml-2" htmlFor={"view_label"}>
              {infoSource.language(infoSource, "label", "viewLabel")}
            </label>
          </div>

          <div>
            <input
              onChange={() => onChangeLabel_tack("View Tracking")}
              type="checkbox"
              id={"view_tracking"}
              className="form-check-input check2"
              checked={label_Tracking[0] ? "checked" : ""}
            />
            <label className="form-check-label ml-2" htmlFor={"view_tracking"}>
              {infoSource.language(infoSource, "label", "viewTracking")}
            </label>
          </div>
        </div>

        {urlTracking && label_Tracking[0] && (
          <iframe
            className="embed-responsive-item"
            src={urlTracking}
            style={{ width: "100%", minHeight: "500px" }}
            title={infoSource.laguangeElakay("frontElakayHardcodedText", infoSource.languageAPI).orderShipped.t004}
          />
        )}

        {url_label && label_Tracking[1] && (
          <div className="col-sm-9 col-md-6 embed-responsive-item">
            <div style={{ width: "100%", height: "100%" }}>
              <ShowimagesLoading
                src={url_label}
                alt={__elakayText("t013", "label ship")}
                style={{ height: "100%", width: "100%" }}
              />
            </div>
          </div>
        )}

        {/* Cancel + "Update Shipping" slider lives in its own always-
            visible section now (shippingActionsSection(), rendered at
            the bottom of TrakingNumberForm()) -- fully independent of
            the payment section/canAcceptCapture. Nothing removed, only
            relocated: same clickBtnInfo/checkInfoBool. */}
      </>
    );
  };

  // SHIPPO/EASYPOST center form: shows what GET /shipping/tracking/order/
  // :oid/:opid already found (task spec "scan/récupération automatique"),
  // then always renders the SAME manual form underneath so a tracking
  // number can still be entered/corrected by hand either way.
  const providerScanCenterForm = (mode) => {
    const providerLabel = mode === "shippo" ? "Shippo" : "EasyPost";
    const { loading, data, error } = providerTrackingState;
    return (
      <>
        <div className="ordersview-section-card" style={{ marginBottom: 16 }}>
          <h5 className="ordersview-section-title">
            {elakayAutoText("h_shipping_provider_scan_title", "Suivi")} {providerLabel}
          </h5>
          {loading && (
            <p>{elakayAutoText("h_shipping_provider_scan_loading", "Recherche d'un suivi existant…")}</p>
          )}
          {!loading && data?.trackingNumber && (
            <div className="ordersview-address-card">
              <h6>{elakayAutoText("h_shipping_provider_scan_found", "Suivi récupéré automatiquement")}</h6>
              <p>{elakayAutoText("h_shipping_carrier", "Transporteur")}: {data.carrier || "—"}</p>
              <p>{elakayAutoText("h_shipping_tracking_number", "Numéro de suivi")}: {data.trackingNumber}</p>
              <p>{elakayAutoText("h_shipping_status", "Statut")}: {data.status || "—"}</p>
              {data.trackingUrl && (
                <p><a href={data.trackingUrl} target="_blank" rel="noreferrer">{data.trackingUrl}</a></p>
              )}
            </div>
          )}
          {!loading && !data?.trackingNumber && !error && (
            <p>{elakayAutoText(
              "h_shipping_provider_scan_not_found",
              "Aucun suivi automatique trouvé pour le moment -- entrez-le manuellement ci-dessous."
            )}</p>
          )}
        </div>
        {manualShippingCenterForm()}
      </>
    );
  };

  const providerFulfillmentSummary = () => (
    <div className="ordersview-address-card">
      <h6>{ot("fulfilledByProvider")}</h6>
      <p>{ot("providerReadOnly")}</p>
      <p>{statusLabel(orders?.products?.status, ot)}</p>
      <p>{ot("trackingNumber")}: {orders?.products?.trackingNumber || orders?.products?.delivery?.trackingNumber || orders?.products?.info?.tracking || "—"}</p>
      {safeTrackingUrl(orders?.products?.trackingUrl || orders?.products?.delivery?.trackingUrl || orders?.products?.info?.urlTracking) && <a href={safeTrackingUrl(orders?.products?.trackingUrl || orders?.products?.delivery?.trackingUrl || orders?.products?.info?.urlTracking)} target="_blank" rel="noreferrer">{ot("viewFulfillment")}</a>}
      <Link className="ordersview-btn-premium ordersview-btn-outline-dark" to="/seller/provider-orders?type=customer">{ot("customerOrders")}</Link>
    </div>
  );

  const TrakingNumberForm = () => (
    <div className="ordersview-premium-container">
      <div style={{ marginBottom: "20px" }}>{ProductView()}</div>

      {!fulfillmentReadOnly && shippingModeSelectorTop()}

      {!fulfillmentReadOnly && (currentShippingMode === "auto" || currentShippingMode === "dropshipping") && autoModeCenterPanel()}
      {!providerFulfilled && (readOnly || currentShippingMode === "manual") && manualShippingCenterForm()}
      {!fulfillmentReadOnly && (currentShippingMode === "shippo" || currentShippingMode === "easypost") && providerScanCenterForm(currentShippingMode)}

      {providerFulfilled && providerFulfillmentSummary()}
      {checkoutState.message && <div className="ordersview-payment-feedback is-success">{checkoutState.message}</div>}
      {!readOnly && processingActionsBottom()}
    </div>
  );

   const graphic = orders.prod_graphic;

  const order = () => (
    <div className="ordersview-premium-container">
      {checkoutState.message && (
        <div className="ordersview-payment-feedback is-success">{checkoutState.message}</div>
      )}
      {checkoutState.error && (
        <div className="ordersview-payment-feedback is-error">{checkoutState.error}</div>
      )}
      {ProductView()}

      <div className="ordersview-info-grid">
        {/* Colonne gauche */}
        <div>
          <div className="ordersview-section-card">
            <h5 className="ordersview-section-title">
              {infoSource.language(infoSource, "sellPage", "DetailsVente")}
            </h5>
            {PaymentVente()}
          </div>

          <div className="ordersview-section-card">
            <h5 className="ordersview-section-title">
              {infoSource.language(infoSource, "sellPage", "detaiAchats")}
            </h5>
            {PaymentAchat()}
          </div>

          {objNotEmpty(orderPayment) && (
            <div className="ordersview-section-card">
              <h5 className="ordersview-section-title">
                {
                  infoSource.laguangeElakay(
                    "title",
                    infoSource.languageAPI
                  ).paymentMethods
                }
              </h5>
              <div className="ordersview-payment-card">
                <h6>
                  {orderPayment.b_brand}{' '}{__elakayText("t008", "ending:")}{orderPayment.b_last4}
                </h6>
                <h6>{__elakayText("t009", "Exp:")}{' '}{orderPayment.b_exp_month} / {orderPayment.b_exp_year}
                </h6>
              </div>
            </div>
          )}
        </div>

        {/* Colonne droite */}
        <div>
          <div className="ordersview-section-card">
            <h5 className="ordersview-section-title">
              {infoSource.language(infoSource, "sellPage", "detAchVent")}
            </h5>
            {PaymentAchVent()}
          </div>

          <div className="ordersview-section-card">
            <h5 className="ordersview-section-title">
              {
                infoSource.laguangeElakay(
                  "title",
                  infoSource.languageAPI
                ).shippnigAddress
              }
            </h5>
            <div className="ordersview-address-card">
              <h6>
                {ordersShipping.firstName} {ordersShipping.lastName}
              </h6>
              <h6>{ordersShipping.line1}</h6>
              <h6>
                {ordersShipping.city}, {ordersShipping.state},{" "}
                {ordersShipping.postal_code}
              </h6>
              <h6>{ordersShipping.country}</h6>
            </div>

            {providerFulfilled && providerFulfillmentSummary()}
            {!readOnly && <div>
              {/* Accept & Capture / Refuse used to live here too as their own
                  standalone controls. They're now grouped inside the "Start
                  Processing" modal (see processingActionsBottom(), rendered
                  at the bottom of TrakingNumberForm()) so that modal is the
                  single place a seller processes an order -- the functions
                  themselves (clickBtnAccept/clickBtnReject) are unchanged,
                  only where their buttons render moved. View Customization
                  stays here, in its original position. */}
              {!fulfillmentReadOnly && graphic && (
                <button
                  className="ordersview-btn-premium ordersview-btn-outline-dark ordersview-btn-track"
                  onClick={() => setShowOrderModal(true)}
                  style={{ width: "100%" }}
                >
                  {__elakayText("t010", "👁️ View Customization")}
                </button>
              )}
              {orders &&
              orders.products &&
              orders.products.status !== "Cancelled" ? (
                <button
                  onClick={() => addTrackNumberBtn()}
                  className="ordersview-btn-premium ordersview-btn-outline-dark ordersview-btn-track"
                  style={{ width: "100%" }}
                >
                  {textButtonProcess(orders.products.status)}
                </button>
              ) : (
                <button
                  className="ordersview-btn-premium ordersview-btn-cancelled"
                  style={{ width: "100%" }}
                  disabled
                >
                  {infoSource.language(infoSource, "label", "statusCancelled")}
                </button>
              )}

              {!fulfillmentReadOnly && <button
                onClick={() => setShowLabel(true)}
                className="ordersview-btn-premium ordersview-btn-outline-dark ordersview-btn-print"
                style={{ width: "100%" }}
              >
                {
                  infoSource.laguangeElakay(
                    "Button",
                    infoSource.languageAPI
                  ).printLabel
                }
              </button>}

              {/* <button
                onClick={() => setShowOrderNote(true)}
                className="ordersview-btn-premium ordersview-btn-outline-dark ordersview-btn-note"
                style={{ width: "100%" }}
              >
                {infoSource.language(infoSource, "Button", "orderNote")}
              </button> */}
            </div>}
          </div>
        </div>
      </div>
    </div>
  );

  const printLabel = () => (
    <div className="container-sm">
      <div className="row justify-content-center">
        <Modal
          size="md"
          show={showLabel}
          onHide={() => setShowLabel(false)}
          dialogClassName="modal-100w"
          aria-labelledby="example-custom-modal-styling-title"
          centered
        >
          <Modal.Header closeButton></Modal.Header>
          <Modal.Body>
            <Printer
              infoSource={infoSource}
              url_label={orders.products.info.url_label}
              setShowLabel={setShowLabel}
            />
          </Modal.Body>
        </Modal>
      </div>
    </div>
  );

  const TrackShow = () => (
    <Modal
      size="xl"
      show={showTracking}
      fullscreen={true}
      onHide={() => setShowTracking(false)}
      dialogClassName="modal-90w"
      aria-label={textButtonProcess(orders?.products?.status)}
    >
      <Modal.Header closeButton>
        <Modal.Title id="example-custom-modal-styling-title"></Modal.Title>
      </Modal.Header>
      <Modal.Body>{TrakingNumberForm()}</Modal.Body>
    </Modal>
  );

  const orderVieux = () => (
    <Modal
      size="xl"
      show={showOrderView && !showTracking}
      fullscreen={true}
      onHide={() => setShowOrderView(false)}
      dialogClassName="modal-90w"
      aria-labelledby="example-custom-modal-styling-title"
    >
      {/* <Modal.Header closeButton>
        <Modal.Title id="example-custom-modal-styling-title"></Modal.Title>
      </Modal.Header> */}
       <button
        type="button"
        className="orders-filter-modal-close"
        onClick={() => setShowOrderView(false)}
        aria-label={infoSource.laguangeElakay("frontElakayHardcodedText", infoSource.languageAPI).orderShipped.t005}
      >
        ×
      </button>
      <Modal.Body>{loading ? <p>{infoSource.laguangeElakay("frontElakayHardcodedText", infoSource.languageAPI).orderShipped.t006}</p> : order()}</Modal.Body>
    </Modal>
  );



  return (
    <>
      {/* {viewOrderNoteMessage()} */}
      {TrackShow()}
      {!showOrderModal &&orderVieux()}
      {!fulfillmentReadOnly && orders &&
        orders.products &&
        orders.products.info &&
        orders.products.info.url_label &&
        printLabel()}

<Modal
  size="xl"
  show={showOrderModal}
  fullscreen={true}
  onHide={() => setShowOrderModal(false)}>
  <Modal.Body style={{ padding: 0 }}>
    <GraffitiOrderSeller 
      order={orders} 
      infoSource={infoSource}
      ImagesProd={galeries|| []}
      onClose={() => setShowOrderModal(false)} 
    />
  </Modal.Body>
</Modal>
         </>
  );
};

export default Orders;
